import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import React, { useMemo } from "react"
import styled from "styled-components"
import { TLanguageSections, TOnClick } from "../../../Interfaces/GlobalInterface"
import H2 from "../../Global/atoms/Text/H2"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import IconButton from "../../Global/atoms/Buttons/IconButton"
import { observer } from "mobx-react"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import InfoBubble from "../../Global/atoms/InfoBubble"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import InputLanguageSelect from "components/ProjectNonSpecificComponents/Elements/InputLanguageSelect"

interface Props {
	buttonsType: THeaderButtonsType
	title: string
	language?: TLanguageSections
	tooltipText?: string
	onClickAddField?: TOnClick<HTMLButtonElement>
	onClickPreview?: TOnClick<HTMLButtonElement>
	onClickDeleteFields?: TOnClick<HTMLButtonElement>
	onClickConnect?: TOnClick<HTMLButtonElement>
}

const AdminPanelFormHeader = observer(
	({
		language,
		buttonsType,
		title,
		tooltipText,
		onClickAddField,
		onClickPreview,
		onClickDeleteFields,
		onClickConnect,
	}: Props) => {
		const { isMobile } = useScreenType()
		const formStore = useFormStore()

		const iconStyle: React.CSSProperties = {
			width: isMobile ? 40 : 80,
			height: isMobile ? 25 : 50,
		}
		const iconSize = 20

		const SideButtons = useMemo(() => {
			switch (buttonsType) {
				case "none":
					return null
				case "add-preview-delete":
					return (
						<>
							{language && (
								<>
									<InputLanguageSelect type={language} />
									<Whitespace h x=".625" />
								</>
							)}
							<IconButton
								iconWidth={iconSize}
								iconHeight={iconSize}
								style={iconStyle}
								iconColor={formStore.settingsData.personalize.colorButton}
								iconKey="add"
								disableUXPadding
								onClick={onClickAddField}
							/>
							<Whitespace h x=".625" />
							<IconButton
								iconWidth={iconSize}
								iconHeight={iconSize}
								style={iconStyle}
								iconColor={formStore.settingsData.personalize.colorButton}
								iconKey="preview"
								disableUXPadding
								onClick={onClickPreview}
							/>
							{!isMobile && (
								<>
									<Whitespace h x=".625" />
									<IconButton
										iconWidth={iconSize}
										iconHeight={iconSize}
										style={iconStyle}
										iconColor={formStore.settingsData.personalize.colorButton}
										iconKey="cross"
										disableUXPadding
										onClick={onClickDeleteFields}
									/>
								</>
							)}
						</>
					)
				case "connect":
					return (
						<IconButton
							style={iconStyle}
							iconColor={formStore.settingsData.personalize.colorButton}
							iconKey="signal"
							onClick={onClickConnect}
						/>
					)
			}
		}, [buttonsType, formStore.settingsData.personalize])

		return (
			<div>
				<Base
					className="center-y"
					style={{
						height: isMobile ? "62px" : "88px",
						fontSize: isMobile ? "20px" : "36px",
					}}
				>
					<H2 className="hide-overflown-text-nowrap">{title}</H2>
					<Whitespace x="1" h />
					{tooltipText && (
						<HyperDiv style={{ marginTop: "7px" }}>
							<InfoBubble tooltipText={tooltipText} />
						</HyperDiv>
					)}

					<div className="center-y" style={{ marginLeft: "auto" }}>
						{SideButtons}
					</div>
				</Base>
				{!isMobile && <Whitespace x="1" />}
			</div>
		)
	}
)

export default AdminPanelFormHeader

const Base = styled.div`
	padding: 0 1.5rem;
	border-bottom: 2px solid var(--gray-ec);
`

export type THeaderButtonsType = "none" | "add-preview-delete" | "connect"
